namespace TabAurous.Common {
    export enum DiscountType {
        Item = 1,
        Process = 2
    }
    Serenity.Decorators.registerEnumType(DiscountType, 'TabAurous.Common.DiscountType', 'Administration.DiscountType');
}
